// extracted by mini-css-extract-plugin
export default {"container":"StoreFrontLayout_container__sLkUS"};